import React, {Component,} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
// import './Edition.css'
import './../../styles/css/screens/Edition/edition.css'
import countries from './../../config/countries.json'
import languages from './../../config/languages.json'

import _ from 'lodash';

import {
    CCUtils,
    updateLocale,
    CCAppEventLogger,
    CCActions,
    getFlag,
    CCGridItem,
    CCButton,
    strings
} from "./../../cc-imports";
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";

class Edition extends Component {

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            country : '',
            language : '',
            loading:false
        };
        this._selectCountry=this._selectCountry.bind(this);
        this._selectLanguage=this._selectLanguage.bind(this);
        this._updateTeams=this._updateTeams.bind(this);
        this._saveDetails=this._saveDetails.bind(this);
    }

    componentWillMount(){
        /*BackHandler.addEventListener('hardwareBackPress', () => {
            if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
                this.props.actions.goBack();
                return true;
            }
            return false;
        });*/
    }

    componentDidMount() {
        if(this.props.user.user){
            this.setState(this.props.user.user);
        }
    }


    _selectCountry(country) {
        CCAppEventLogger.logAppEvent("CountrySelected", {country : country.key, loggedIn:CCUtils.isLoggedIn(this.props.user)});
        this.setState({country : country.key});

        this.props.actions.updateCountry(this.props.user.user, country.key).then(()=>{
            this.props.actions.editionChanged();
        })
    }

    _selectLanguage(language) {
        CCAppEventLogger.logAppEvent("LanguageSelected", {language : language.key, loggedIn:CCUtils.isLoggedIn(this.props.user)});
        this.setState({language : language.key});
        this.props.actions.updateLanguage(this.props.user.user,  language.key);
        this._updateTeams(language.key);
    }

    _updateTeams(team) {
        var teams = this.state.teams;
        if(teams==null) teams=[];
        if(_.find(teams,(key)=>{return key==team.key})){
            _.remove(teams,(key)=>{return key==team.key});
        }
        else {
            teams = _.concat(teams,team.key)
        }
        this.setState({teams : teams});
        this.props.actions.updateSettings(this.props.user.user, Object.assign(this.state, {teams : teams}));
    }

    _saveDetails(){
        this.setState({loading:true});
        this.setState({loading:false});
    }


    render() {
        let user = this.props.user.user;
        return (
            <CCErrorBoundary>
            <div className="sidebar-sub-background">
                <div className="flex-container" style={{resizeMode: 'cover'}}>
                    <div style={{alignItems: 'center', justifyContent: 'center', width: 150}}>
                        <div className="flex-container edition-header">
                            <h1 style={{fontSize: 25}}>{strings('edition')}</h1>
                        </div>

                        <div className="flex-container" style={{flex: 1, width: 550}}>
                            <h1 className="pick-country-title">{strings('pick_your_country')}</h1>
                        </div>
                        <div className="flex-container pick-country-title2 ">
                            <h4>{strings('select_country')}</h4>
                        </div>
                        <div className="gridView edition-scroll" style={{flex:1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>

                            {
                                countries.countries.map((country)=> {
                                    return (<CCGridItem selected={this.state.country == country.key} onPress={()=> {
                                        this._selectCountry(country)
                                    }} type={'country'} item={country}></CCGridItem>)
                                })
                            }
                        </div>

                        <div className="flex-container select-lang-title">
                            <h1>{strings('select_language')}</h1>
                        </div>


                        <div className={'flex-container'} style={{flex:1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '32vw'}}>
                            {
                                languages.languages.map((language)=> {
                                    return (<div style={{border: '1px'}}>
                                        <CCGridItem selected={this.state.language == language.key} onPress={()=> {
                                            this._selectLanguage(language)
                                        }} type={'language'} item={language}></CCGridItem>
                                    </div>)
                                })
                            }
                        </div>




                        <div className={'flex-container'} style={{flex:1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '32vw'}}>
                            <CCButton style={{width: '51vw', height: 50,borderRadius: '5px'}}
                                      title={strings('save')} titleSize={15} onPress={()=> {this._saveDetails()}}></CCButton>
                        </div>
                        {
                            false &&
                            <div className="flex-container" style={{flex: 1}}>


                            </div>

                        }
                    </div>
                </div>
            </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state=>({
    profile: state.profile,
    profileTabNavigation: state.profileTabNavigation,
    user: state.user,
    fireBaseUser: state.fireBaseUser
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(Edition);


// WEBPACK FOOTER //
// ./src/app/screens/Edition/Edition.js